import ajax from './index'

//小店交易明细列表
export function shopTransactionList(data){
    return ajax.post('/admin/shop/transaction/list',data)
}

//小店交易明细-详情
export function shopTransactionDetail(data){
    return ajax.post('/admin/shop/transaction/detail',data)
}


//满减券列表
export function activityPreferentialCouponList(data){
    return ajax.post('/admin/activity/preferential/coupon_list',data)
}

//满减券领取记录
export function activityPreferentialDetailList(data){
     return ajax.post('/admin/activity/preferential/detail_list',data)
}

//满减券删除
export function activityPreferentialDelete(data){
     return ajax.post('/admin/activity/preferential/delete',data)
}


//小店提现列表
export function withDrawList(data){
    return ajax.post('/admin/withdraw/list',data)
}

//小店提现导出
export function withdrawExport(data){
    return ajax.post('/admin/withdraw/export',data)
}
//小店提现详情
export function withDrawalDetail(data){
     return ajax.post('/admin/withdraw/detail',data)
}

//小店提现驳回
export function withDrawRefuse(data){
    return ajax.post('/admin/withdraw/refuse',data)
}

//小店提现通过
export function withDrawPass(data){
    return ajax.post('/admin/withdraw/pass',data)
}


//佣金收入列表获取
export function searchOnlineIncomes(url){
    return ajax.get('/admin/shop/incomes/search' + url)
}

//小店收入明细
export function shopIncomesData(url){
    return ajax.get('/admin/shop/incomes/search?'+url)
}

//小店收入明细详情
export function shopIncomgetDetailData(id){
    return ajax.get('/admin/shop/income/'+id+'/get')
}

//自营商品结算列表
export function settleSelfsupportList(data){
    return ajax.post('/admin/settle/self_support/list',data)
}

//结算
export function  settleSelfsupportSelect(data){
    return ajax.post('/admin/settle/self_support/settle',data)
}

//代扣税列表
export function taxAdminTaxRecord(data){
    return ajax.post('/admin/tax/tax_record',data)
}

//抵扣申请记录
export function  taxDeductRecord(data){
    return ajax.post('/admin/tax/deduct_record',data)
}

//申请抵扣记录详情
export function taxDeductDetail(data){
    return ajax.post('/admin/tax/deduct_detail',data)
}

//申请抵扣审核
export function taxDeductOperate(data){
    return ajax.post('/admin/tax/operate',data)
}
